module.exports = __webpack_public_path__ + "img/icon_location_in_active.26345cb7.png";